
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      max-width="1000px"
      transition="dialog-transition"
      style="border-radius: 40px;"
    >
      <base-card>
        <template slot="title">
          <span class="text-capitalize pa-3 font-weight-bold">
            {{ $tc('financials.edit')}}
          </span>
        </template>

        <template v-slot:content>
          <v-form ref="movementForm" :disabled="!is_editing" v-if="!loading" class="px-3">
            <v-row justify='end' align='center' class="pa-3">
              <v-col class="pa-1" cols="12" sm="6" md="12" lg="3">
                <!-- <v-row align='center'> -->
                  <!-- <div>{{$tc('financials.description_form_label')}}</div> -->
                  <v-text-field rounded outlined dense class="rounder" 
                    :label="$tc('financials.description_form_label')"
                    v-model="one_movement.name"
                    :rules="required"
                  ></v-text-field>
                <!-- </v-row> -->
              </v-col>
              <v-col class="pa-1" cols="12" sm="6" md="4" lg="3">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$tc('financials.value_form_label')"
                  prefix="R$"
                  v-model="one_movement.value"
                  :rules="not_zero"
                  v-currency="currency"
                ></v-text-field>
              </v-col>
              <v-col class="pa-1" cols="12" sm="6" md="3" lg="3">
                <v-select rounded outlined dense class="rounder" 
                  :label="$tc('financials.kind_form_label')"
                  :items="kind_options"
                  item-text="text"
                  item-value="value"
                  v-model="one_movement.kind"
                  :rules="required"
                ></v-select>
              </v-col>
              <v-col class="pa-1" cols="12" sm="6" md="3" lg="3">
                <!-- <v-text-field rounded outlined dense class="rounder" 
                  :label="$tc('financials.due_form_label')"
                  v-model="one_movement.due_date"
                  :rules="required"
                ></v-text-field> -->
                <vc-date-picker v-model="one_movement.due_date" :popover="{placement: 'bottom-start', positionFixed: true}">
                  <template v-slot="{ inputValue, togglePopover }">
                    <v-text-field rounded outlined dense class="rounder" 
                      :label="$tc('financials.due_form_label')"
                      :value="$dayjs(one_movement.due_date).format('DD/MM/YYYY')"
                      :rules="required"
                      @focus="togglePopover()"
                      readonly
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
              <v-col class="pa-1" cols="12" sm="6" md="3" lg="3">
                <v-select rounded outlined dense class="rounder" 
                  :label="$tc('financials.status_form_label')"
                  :items="status_options"
                  item-text="text"
                  item-value="value"
                  v-model="one_movement.status"
                  :rules="required"
                ></v-select>
              </v-col>
              <!-- <v-col class="pa-1" cols="12" sm="6" md="4" lg="3">5</v-col> -->
              <!-- <v-col class="pa-1" cols="12" sm="6" md="4" lg="3">5</v-col> -->
            </v-row>
          </v-form>
          </template>

        <template slot="actions">
          <template v-if="is_editing">
            <v-btn small color="error" class="font-weight-bold" @click="cancelMovement" text>{{ $t('cancel') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn small color="primary" class="font-weight-bold" @click="saveMovement" text>{{ $t('save') }}</v-btn>
          </template>
          <template v-if="!is_editing">
            <v-spacer></v-spacer>
            <v-btn small color="primary" class="font-weight-bold" @click="is_editing = true" text>{{ $t('edit') }}</v-btn>
          </template>
        </template>

      </base-card>
    </v-dialog>

    <dialog-loading v-if="saving" loadingText="saving" ></dialog-loading>
    <dialog-loading v-if="loading" loadingText="loading" ></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';
import {CurrencyDirective} from 'vue-currency-input'

export default {
  name: 'DialogEditMovement',
  mixins: [ validations ],
  directives: {
    currency: CurrencyDirective,
  },
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,

      is_editing: false,

      loading: false,
      saving: false,

      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },

      
      one_movement: {
      },

      kind_options: [
        {text: this.$t('financials.kinds.income'), value: 'income'},
        {text: this.$t('financials.kinds.outcome'), value: 'outcome'},
      ],
      
      status_options: [
        {text: this.$t('financials.statuses.open'), value: 'open'},
        {text: this.$t('financials.statuses.payed'), value: 'payed'},
        {text: this.$t('financials.statuses.overdue'), value: 'overdue'},
        {text: this.$t('financials.statuses.canceled'), value: 'canceled'},
      ],
    }
  },
  methods: {
    cancelMovement(){
      this.is_editing=false
    },
    getMovement(){
      this.loading = true
      Api.Movement.show(this.$route.params.id).then(r=> r.data).then(d=> {
        const {value, ...movement} = d
        this.one_movement = {
          ...movement,
          value: (value/100).toFixed(2)
          // ...json_attributes
        }
      }).catch(err=> {
        console.log({err});
      }).finally(()=>{
        setTimeout(() => {
          this.loading = false
        }, 500);
      })
    },
    saveMovement(){
      if (this.$refs.movementForm.validate()){
        this.saving = true
        let {value, due_date, ...mov} = this.one_movement
        due_date = this.$dayjs(due_date).format()
        value = Number(value.replace(/,/g, ''))*100
        Api.Movement.update({...mov, value, due_date}).then(r=> {
          this.$router.go(-1)
        }).catch(err=> {
          console.log({err});
        }).finally(()=>{
          this.saving = false
        })
      }
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getMovement();
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
  
      } else if (nv == false){
        this.$router.go(-1)
      }
    }
  },
}
</script>

<style scoped>

</style>